<template>
  <div class="preiod-report-page">
    <!-- <div class="nav">
      <span>彩种</span>
      <DropDownMenu :dropList="gameList" v-model="choiceOption" />
    </div> -->
    <table class="preiod-report-table" cellpadding="0" cellspacing="0">
      <thead>
        <tr>
          <th style="width: 310px">期数</th>
          <th>笔数</th>
          <th>下注金额</th>
          <th>有效金额</th>
          <th>中奖</th>
          <th>回水</th>
          <th>盈亏</th>
        </tr>
      </thead>
      <tbody id="betList">
        <tr v-for="(item, index) in list" :key="index">
          <td @click="goBetDetail(item.qihao)">
            <a
              class="active-text"
              href="javascript:void(0)"
              style="cursor: pointer"
              >{{ item.qihao }}</a
            >
          </td>
          <td>{{ item.issueNum }}</td>
          <td>{{ (item.betMoney * 1).toFixed(2) }}</td>
          <td>
            {{ item.ispei == 0 ? "-" : (item.vaildMoney * 1).toFixed(2) }}
          </td>
          <td>{{ item.ispei == 0 ? "-" : (item.drawMoney * 1).toFixed(2) }}</td>
          <td>{{ item.ispei == 0 ? "-" : (item.backMoney * 1).toFixed(2) }}</td>
          <td :style="{ color: item.winorlose < 0 ? 'red' : 'green' }">
            {{ item.ispei == 0 ? "-" : (item.winorlose * 1).toFixed(2) }}
          </td>
        </tr>
        <tr
          v-if="list.length != 0"
          style="
            font-weight: bolder;
            background: var(--new-bg-table-summary);
            color: var(--new-text-info);
          "
        >
          <td class="bold">合计</td>
          <td>{{ (sum(list, "issueNum") * 1).toFixed(2) }}</td>
          <td>{{ (sum(list, "betMoney") * 1).toFixed(2) }}</td>
          <td>{{ (sum(list, "vaildMoney") * 1).toFixed(2) }}</td>
          <td>{{ (sum(list, "drawMoney") * 1).toFixed(2) }}</td>
          <td>{{ (sum(list, "backMoney") * 1).toFixed(2) }}</td>
          <td :style="{ color: sum(list, 'winorlose') < 0 ? 'red' : 'green' }">
            {{ (sum(list, "winorlose") * 1).toFixed(2) }}
          </td>
        </tr>
        <tr v-if="list.length == 0">
          <td colspan="10" style="background: transparent; height: 300px">
            <div class="noData"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DropDownMenu from "@/components/DropDownMenu";
export default {
  data() {
    return {
      choiceOption: "hn5fc",
      gameList: [],
      list: [],
    };
  },
  components: {
    DropDownMenu,
  },
  mounted() {
    this.initData();
  },
  props: ["initFinished"],
  methods: {
    initData() {
      if (this.initFinished) {
        this.computedGameList();
        this.getList();
      }
    },
    computedGameList() {
      this.$store.state.gameInfo.forEach((element) => {
        this.gameList.push({
          label: element.gameName,
          value: element.code,
        });
      });
    },
    async getList() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
      };
      let result = await this.$http.postAxiosMethod("/user/issuereport", data);
      if (result.code == 0) {
        this.list = result.data;
      }
    },
    goBetDetail(issue) {
      this.$emit("goBetDetail", issue);
    },
    sum(list, key) {
      let sum = 0;
      list.forEach((item) => {
        if (key == "num") {
        }
        if (item.winorlose || item.peie) {
          sum += item[key] * 1;
        } else {
          sum += 0;
        }
      });
      return sum || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.preiod-report-page {
  background: var(--new-bg-white);
  .nav {
    // margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 14px 0 0;
    height: 40px;
    font-size: 13px;
    background: #ffecda;
    & > span {
      margin: 0 15px;
    }
    .search {
      margin-left: 45px;
      width: 60px;
      height: 25px;
      background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
      border-radius: 2px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .preiod-report-table {
    // margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
    font-size: 12px;
    background: var(--new-bg-white);
    th {
      padding: 0 20px;
      font-weight: bold;
      color: var(--new-text-info);
      background: var(--new-bg-table-header-main);
      line-height: 30px;
      height: 30px;
      text-align: left;
    }
    td {
      line-height: 30px;
      height: 30px;
      text-align: left;
      padding: 0 20px;
      border-bottom: 1px solid var(--new-border);
    }
    tr {
      // &:nth-child(n) {
      //   background: #f0f0f0;
      // }
      // &:nth-child(2n) {
      //   background: #fff;
      // }
    }
  }
}
</style>
